import BaseService from '../BaseService'

export default class BrancheService extends BaseService {
  constructor() {
    super('public/branche')
  }
}
